import moment from 'moment'
import $const from '@/utils/const'

export default {
    data () {
        let ruleRequired = v => (v !== null && v !== undefined && v !== '') || this.$t('formRules.fieldRequired')
        let ruleCounter = count => {
            return v => {
                if (v && v.length > count) {
                    return this.$t('formRules.fieldTooLong', [count])
                }
                return true
            }
        }
        let reg = new RegExp('^[a-zA-Z\\d\\._\\- ]+$')
        let ruleProjectName = v => reg.test(v) || this.$t('projectNameInvalid')
        let ruleDateTime = dateTime => moment(dateTime).isValid() || this.$t('formRules.dateTimeNotCorrect')
        let ruleDatePicker = date =>
            moment(date, $const.DATE_FORMAT, true).isValid() ||
            this.$t('formRules.dateNotCorrect')
        let rulePhone = v => (
            /^[0-9\-+]{9,15}$/.test(v) ||
            this.$t('formRules.fieldNotValid', [this.$filters.capitalize(this.$t('phoneNumber'))])
        )
        let ruleAgentQuickResponseTitle = v => !((v || '').includes('<') || (v || '').includes('>')) || this.$t('formRules.fieldInvalid')
        let ruleEmail = v => /.+@.+/.test(v) || this.$t('formRules.fieldNotValid', ['Email'])
        let ruleMin = min => {
            return v => {
                if (isNaN(v)) {
                    return this.$t('formRules.notANumber')
                }
                return Number(v) >= min || this.$t('formRules.minValue', [min])
            }
        }
        return {
            formRules: {
                ruleRequired,
                ruleCounter,
                ruleProjectName,
                ruleDateTime,
                ruleDatePicker,
                rulePhone,
                ruleEmail,
                ruleMin,
                ruleAgentQuickResponseTitle,
                required: [ruleRequired],
                email: [ruleRequired, ruleEmail],
                projectName: [ruleRequired, ruleProjectName]
            }
        }
    }
}
